/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FoldersContainer_viewer$ref = any;
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosSortByTypes = "ALPHABETICAL" | "CREATED" | "CUSTOM" | "MODIFIED" | "%future added value";
export type FoldersContainerRefetchQueryVariables = {
    readonly first: number;
    readonly after?: string | null;
    readonly hasUserId: boolean;
    readonly portfolioTypes?: ReadonlyArray<PortfolioTypes | null> | null;
    readonly foldersSort?: PortfoliosSortByTypes | null;
    readonly loadPortfolioData: boolean;
    readonly selectedItemIds: ReadonlyArray<string | null>;
    readonly userId: string;
    readonly userIds: ReadonlyArray<string | null>;
    readonly page: number;
};
export type FoldersContainerRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FoldersContainer_viewer$ref;
    } | null;
};
export type FoldersContainerRefetchQuery = {
    readonly response: FoldersContainerRefetchQueryResponse;
    readonly variables: FoldersContainerRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "after",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "portfolioTypes",
            "type": "[PortfolioTypes]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "foldersSort",
            "type": "PortfoliosSortByTypes",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any), v5 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        (v6 /*: any*/),
        (v3 /*: any*/)
    ], v8 = ({
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    } as any), v9 = ({
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    } as any), v10 = ({
        "kind": "Variable",
        "name": "portfolioTypes",
        "variableName": "portfolioTypes"
    } as any), v11 = ({
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "foldersSort"
    } as any), v12 = [
        (v8 /*: any*/),
        (v9 /*: any*/),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any),
        (v10 /*: any*/),
        (v11 /*: any*/),
        (v5 /*: any*/)
    ], v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "numberOfPages",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
    } as any), v16 = [
        (v13 /*: any*/),
        (v14 /*: any*/),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                },
                (v15 /*: any*/)
            ]
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfoliosEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                        },
                        (v3 /*: any*/),
                        (v6 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 4
                                },
                                {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "CUSTOM"
                                }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "pageInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "startCursor",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v15 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemsEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioItemV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "photos",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ItemPhoto",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "versions",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ItemPhotoVersion",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "webPath",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                (v3 /*: any*/)
                                                            ]
                                                        },
                                                        (v3 /*: any*/)
                                                    ]
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v17 = [
        (v8 /*: any*/),
        (v9 /*: any*/),
        (v10 /*: any*/),
        (v11 /*: any*/),
        (v5 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FoldersContainerRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FoldersContainer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FoldersContainerRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": "trendingCategories",
                            "name": "trending",
                            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "categoryLevels",
                                    "value": 3
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "CATEGORY"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v2 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "trendingAttributes",
                            "name": "trending",
                            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
                            "args": [
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "ATTRIBUTE"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v2 /*: any*/)
                        },
                        (v3 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "selectedItemIds"
                                        },
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioItemId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        (v4 /*: any*/),
                                        (v5 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "userId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isVerifiedTrade",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "currency",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "foldersPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": (v16 /*: any*/)
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "foldersPortfolios",
                                    "name": "portfolios",
                                    "args": (v12 /*: any*/),
                                    "handle": "connection",
                                    "key": "FoldersRefetchWrapper_foldersPortfolios",
                                    "filters": [
                                        "portfolioTypes",
                                        "sortBy",
                                        "userIds",
                                        "page"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": (v17 /*: any*/),
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": (v16 /*: any*/)
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "portfolios",
                                    "args": (v17 /*: any*/),
                                    "handle": "connection",
                                    "key": "FoldersPaginationWrapper_portfolios",
                                    "filters": [
                                        "portfolioTypes",
                                        "sortBy",
                                        "userIds"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FoldersContainerRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/FoldersContainerRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '2d465797f4694a35f82e25f5590b9c45';
export default node;
